import React from 'react';
import Head from 'next/head';
import { Link, Spacer } from 'vcc-ui';
import { PageLayout } from './page';

export default function Layout({
  children,
  title,
  isIndexPage = false,
  currentTheme,
  setCurrentTheme,
}) {
  return (
    <>
      <Head>
        <title>{title} - Blog</title>
      </Head>
      <PageLayout setCurrentTheme={setCurrentTheme} currentTheme={currentTheme}>
        <Spacer size={3} />
        {!isIndexPage ? (
          <Link arrow="left" href="/blog">
            All posts
          </Link>
        ) : null}
        <Spacer size={3} />
        {children}
      </PageLayout>
    </>
  );
}
